import { AxiosInstance } from 'axios';

import BaseClient from './baseClient';
import { BaseDataResponse, BaseResponse } from '../responses';
import { IErrorHandler } from '../abstractions';
import { FilePublicModel } from '../interfaces';

export default class ClaimClient extends BaseClient {
  constructor(errorHandler: IErrorHandler, axiosInstance: AxiosInstance) {
    super(errorHandler, axiosInstance, 'claim');
  }

  public async postMessageAsync(mutation: FormData): Promise<BaseResponse> {
    return this.postFormDataHttpAsync<BaseResponse>('question', mutation);
  }

  public async downloadDocumentFileAsync(documentId: string): Promise<BaseDataResponse<FilePublicModel>> {
    return this.getHttpAsync<BaseDataResponse<FilePublicModel>>(`document/${documentId}`, ``);
  }

  /* public async downloadDocumentFileAsync(documentId: string): Promise<Blob | undefined> {
    return this.getHttpBinaryAsync(`document/${documentId}`, ``);
  } */
}
